import type { FaireProductEntity } from "../../entity_types/product";

export const p_rv535muhjj: FaireProductEntity = {
  token: "p_rv535muhjj",
  type: "product",
  name: "Mother's Day Self Care Gifts Soy Wax Candle - 10 oz.",
  brandToken: "b_d7pmygnptu",
  brandName: "Ashbury Bloom",
  imageUrl:
    "https://cdn.faire.com/fastly/7348d55ad587af4f39792574a3e1f1b92fe09e5096b612f5bf67d3fe76c72bd5.webp",
  galleryImageUrls: [],
  priceDollars: 12,
  description:
    "Mother's Day Soy Wax Candle - Lavender + Eucalyptus | Eco-Friendly, Hand-Poured\n\nOffer your customers a heartfelt gift they’ll love with our Mother's Day Soy Wax Candle, infused with the delicate scent of Lavender + Eucalyptus. This candle combines beauty and sustainability, making it a standout item for any store’s gift selection.\n\nCrafted with 100% soy wax, this candle provides a clean burn with a lead-free, unbleached cotton wick, ensuring a long-lasting scent and a safe, eco-friendly experience. Free from phthalates and parabens, it aligns with consumer demand for sustainable and green products.\n\nIdeal for Mother’s Day, this candle’s personalized message adds a unique touch that will resonate with your customers. With its elegant design and premium ingredients, it offers an upscale yet affordable gift option.\n\nScent Profile: Lavender + Eucalyptus \nSize: 10 oz.\nMade in Canada\nUp to 60hrs of clean burn time\nPhthalate and paraben-free",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:25.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
